/**
 * 最近見た商品管理スクリプト
 * 
 * 概要:
 * - 最近見た商品の表示数を制限する機能を提供
 * - MutationObserverを使用してDOMの変更を監視
 * - 表示上限を超える商品を非表示にする
 * - hb-recent-productsクラスを持つ要素のスライダーを対象に動作
 * - hb-recent-products内のスライダーコントロールのみを有効化
 * 
 * 制限事項:
 * - hb-recent-products要素のdata-count属性に最大表示数が設定されていること
 * - Swiper.jsを使用したスライダーであること
 */

document.addEventListener('DOMContentLoaded', function() {
  // 商品数を制限する関数
  function limitProductCount(container) {
    if (!container) return;
    
    const maxProducts = parseInt(container.dataset.count, 10);
    if (isNaN(maxProducts)) return;
    
    const productSlides = container.querySelectorAll('.swiper-slide');
    
    // 設定された数以上の商品がある場合、超過分を非表示にする
    if (productSlides.length > maxProducts) {
      for (let i = maxProducts; i < productSlides.length; i++) {
        productSlides[i].style.display = 'none';
      }
      return true; // 制限が適用された
    }
    return false;
  }

  // スライダーコントロールの設定関数
  function setupSliderControls() {
    // hb-recent-products内のスライダーコントロールのみを対象にする
    const recentProductsContainer = document.querySelector('.hb-recent-products');
    if (!recentProductsContainer) return;
    
    // コンテナ内のSwiperインスタンスを特定
    const swiperEl = recentProductsContainer.querySelector('.swiper');
    if (!swiperEl) return;
    
    // Swiperインスタンスがまだ初期化されていない場合、待機する
    const checkSwiperInstance = function() {
      if (swiperEl.swiper) {
        const swiperInstance = swiperEl.swiper;
        
        // コントロールボタンを取得
        const prevButton = recentProductsContainer.querySelector('.banner-button-prev');
        const nextButton = recentProductsContainer.querySelector('.banner-button-next');
        
        if (!prevButton || !nextButton) return;
        
        // すべてのイベントリスナーを削除
        const newPrevButton = prevButton.cloneNode(true);
        const newNextButton = nextButton.cloneNode(true);
        
        prevButton.parentNode.replaceChild(newPrevButton, prevButton);
        nextButton.parentNode.replaceChild(newNextButton, nextButton);
        
        // 新しいイベントリスナーを追加
        newPrevButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          swiperInstance.slidePrev();
          return false;
        });
        
        newNextButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          swiperInstance.slideNext();
          return false;
        });
        
        // データ属性を追加して、このボタンが初期化済みであることを示す
        newPrevButton.setAttribute('data-hb-initialized', 'true');
        newNextButton.setAttribute('data-hb-initialized', 'true');
        
        // 矢印ボタンのアクティブ状態を更新する関数
        function updateArrowState() {
          // 最初のスライドの場合、前へボタンを非アクティブに
          if (swiperInstance.isBeginning) {
            newPrevButton.classList.add('swiper-button-disabled');
          } else {
            newPrevButton.classList.remove('swiper-button-disabled');
          }
          
          // 最後のスライドの場合、次へボタンを非アクティブに
          if (swiperInstance.isEnd) {
            newNextButton.classList.add('swiper-button-disabled');
          } else {
            newNextButton.classList.remove('swiper-button-disabled');
          }
        }
        
        // 初期状態の設定
        updateArrowState();
        
        // スライド変更時にアロー状態を更新
        swiperInstance.on('slideChange', updateArrowState);
        swiperInstance.on('resize', updateArrowState);
      } else {
        // Swiperがまだ初期化されていない場合は再試行
        setTimeout(checkSwiperInstance, 100);
      }
    };
    
    checkSwiperInstance();
  }

  // 最近見た商品のロード後に実行される処理
  document.addEventListener('recent-products-loaded', function(e) {
    const container = document.querySelector('.hb-recent-products');
    limitProductCount(container);
    setupSliderControls();
  });

  // MutationObserverを使用して、スライダーに商品が追加されたことを検知
  const observer = new MutationObserver(function(mutations) {
    const container = document.querySelector('.hb-recent-products');
    if (limitProductCount(container)) {
      // 変更を検知して制限が適用されたら監視を停止
      observer.disconnect();
    }
  });

  // スライダーの監視を開始
  const swiperWrapper = document.querySelector('.hb-recent-products .swiper-wrapper');
  if (swiperWrapper) {
    observer.observe(swiperWrapper, { childList: true });
  }
  
  // バックアップとして定期的にチェック
  const checkInterval = setInterval(function() {
    const container = document.querySelector('.hb-recent-products');
    if (!container) return;
    
    const productSlides = container.querySelectorAll('.swiper-slide');
    
    if (productSlides.length > 0) {
      if (limitProductCount(container)) {
        // 商品が見つかり制限が適用されたらインターバルを停止
        clearInterval(checkInterval);
        setupSliderControls(); // 制限適用後にコントロールを初期化
      }
    }
  }, 500);
  
  // window load時にも確認
  window.addEventListener('load', function() {
    const container = document.querySelector('.hb-recent-products');
    limitProductCount(container);
    setupSliderControls();
  });
});
